import { Typo } from "@ui/text/Typo";
import { HBox } from "@ui/box/Box";

interface IAquirerListItemProps {
	acquirer: IAcquirer;
	onSelect: () => void;
}

export const AquirerListItem = ({
	acquirer,
	onSelect,
}: IAquirerListItemProps) => {
	return (
		<HBox
			onClick={onSelect}
			gap="16px"
			sx={{
				padding: "20px",
				backgroundColor: "#c6deff",
				borderRadius: "12px",
				cursor: "pointer",
			}}>
			<Typo
				variant="text"
				sx={{ userSelect: "none", marginRight: "auto" }}>
				{acquirer.id}
			</Typo>

			<Typo
				variant="text"
				sx={{ userSelect: "none", marginRight: "auto" }}>
				{acquirer.name}
			</Typo>
		</HBox>
	);
};
